import { render, staticRenderFns } from "./menuFooter.vue?vue&type=template&id=cc785aee&scoped=true&"
import script from "./menuFooter.vue?vue&type=script&lang=js&"
export * from "./menuFooter.vue?vue&type=script&lang=js&"
import style0 from "./menuFooter.vue?vue&type=style&index=0&id=cc785aee&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cc785aee",
  null
  
)

export default component.exports